import { AcceptanceStatus, DocumentStatus } from '@dealstack/shared/lib/generated';
import { EXPECTED_STATUS } from '@dealstack/shared/lib/common/business/kyc';

export enum ManageInvestmentsTableColumn {
	investmentWorkflowId = 'investmentWorkflowId',
	investorId = 'investorId',
	investor = 'investor',
	cohorts = 'cohorts',
	type = 'type',
	allocations = 'allocations',
	kyc = 'kyc',
	contracts = 'contracts',
	payment = 'payment',
	status = 'status',
	createdAt = 'createdAt',
	updatedAt = 'updatedAt',
}

export enum EligibilityFilter {
	RELEASE = 'release',
	INVITE = 'invite',
	REVOKE = 'revoke',
	UPDATE_ALLOCATIONS = 'update_allocations',
	TRANSACTION_TYPE = 'transaction_type',
}

export const ORDERED_KYC_STATUSES = [
	EXPECTED_STATUS,
	AcceptanceStatus.PENDING,
	AcceptanceStatus.APPROVED,
	AcceptanceStatus.REREQUESTED,
];

export const ORDERED_CONTRACTS_STATUSES = [
	DocumentStatus.NA,
	DocumentStatus.PENDING,
	DocumentStatus.COMPLETE,
	DocumentStatus.COMPLETED_OUTSIDE_DEALSTACK,
	DocumentStatus.INCOMPLETE,
];
